import { ListboxOption } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export class OptionComponent extends ChameleonElementMixin(ListboxOption) {
    get label() {
        var _a;
        return (_a = this.getAttribute('label')) !== null && _a !== void 0 ? _a : this.text;
    }
}
